import {
  RingProgress as MantineRingProgress,
  RingProgressProps as MantineRingProgressProps,
} from "@mantine/core"
import { forwardRef } from "react"

type RingProgressSection = Omit<
  MantineRingProgressProps["sections"][number],
  "color"
> & {
  color?: string
}

type RingProgressProps = Omit<MantineRingProgressProps, "sections"> & {
  sections: RingProgressSection[]
}

export const RingProgress = forwardRef<HTMLDivElement, RingProgressProps>(
  (
    {
      size = 100,
      thickness = 3,
      sections,
      label,
      rootColor = "var(--progress-bar-color-unfilled)",
      ...props
    },
    ref
  ) => {
    const sectionsWithDefaults = sections.map((section) => ({
      ...section,
      color: section.color ?? "var(--progress-bar-color-filled)",
    }))

    return (
      <MantineRingProgress
        ref={ref}
        {...props}
        size={size}
        thickness={thickness}
        sections={sectionsWithDefaults}
        label={label}
        rootColor={rootColor}
      />
    )
  }
)
